import apiClient from './axios.js';

/**
 * 認證 API
 */
export const authApi = {
  /**
   * 系統帳號登入
   * @param {Object} loginData - 登入資料
   * @param {string} loginData.username - 使用者名稱
   * @param {string} loginData.password - 密碼
   * @param {string} [loginData.identityMode] - 身份模式 (system/platform/client)
   * @returns {Promise<Object>} 登入結果
   */
  systemLogin: async (loginData) => {
    const response = await apiClient.post('/auth/system/login', loginData);
    return response;
  },

  /**
   * 平台帳號登入
   * @param {Object} loginData - 登入資料
   * @param {string} loginData.platformCode - 平台代碼
   * @param {string} loginData.username - 使用者名稱
   * @param {string} loginData.password - 密碼
   * @returns {Promise<Object>} 登入結果
   */
  platformLogin: async (loginData) => {
    const response = await apiClient.post('/auth/platform/login', loginData);
    return response;
  },

  /**
   * 客戶帳號登入
   * @param {Object} loginData - 登入資料
   * @param {string} loginData.platformCode - 平台代碼
   * @param {string} loginData.clientCode - 客戶代碼
   * @param {string} loginData.username - 使用者名稱
   * @param {string} loginData.password - 密碼
   * @returns {Promise<Object>} 登入結果
   */
  clientLogin: async (loginData) => {
    const response = await apiClient.post('/auth/client/login', loginData);
    return response;
  },

  /**
   * 登出
   */
  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    localStorage.removeItem('auth_account_type');
  },
};
